import { TD, getHeaderActiveColumns } from "../../../../util/table";
import { ModalProvider } from "../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../Table/TableBasic";
import DataDlIcon from "../../../icons/DataDlIcon";
import { useHardcodedQuery } from "../../../../hooks/useQueries";
import { DATAUDTRAEK } from "../../../../constants/hardcodedData";
import { SortBy } from "../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import useActiveColumns from "../../../../hooks/useActiveColumns";
import { defaultDataudtraekColumns } from "../../../../config/admin/columnsConfig";
import { DownloadModalWithRoot } from "../../../Modal/modals/DownloadModal";
import Spinner from "../../../spinner/Spinner";
import { openReportWithAuth } from "../../../../api/util";
import IngenRegistreringer from "../../person/id/IngenRegistreringer";
import DownloadIcon from "../../../icons/DownloadIcon";
import Button from "@/components/bricks/button/Button";
import { KursusKategoriDownloadModalWithRoot } from "../../../Modal/modals/KursusKategoriDownloadModal";
import { orderBy } from "../../../../util/orderBy";

export default function Dataudtraek() {
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "adminDataudtraekSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );
  const [activeColumns] = useActiveColumns(
    "admin-dataudtraek-active-columns",
    defaultDataudtraekColumns,
  );
  const {
    data: dataudtraek,
    error,
    isPending,
  } = useHardcodedQuery(DATAUDTRAEK);
  if (error) return <div>Fejl</div>;
  if (isPending) return <Spinner size={24} />;
  if (!dataudtraek) return <IngenRegistreringer />;
  return (
    <div className="container">
      <h3 className="d-flex gap-2 align-items-center">
        <span className="c-theme-icon c-theme-icon--defaultSize text-primary bg-primary-light">
          <DataDlIcon width={18} />
        </span>
        <span>Dataudtræk</span>
      </h3>
      <div className="table-responsive">
        <ModalProvider>
          <TableRoot className="table--clear-empty-columns table--columns-truncate">
            <TableHead>
              <>
                {getHeaderActiveColumns(activeColumns, {
                  defaultSortBy,
                  setSortBy,
                  sortBy,
                })}
                <th className="edit-column">
                  <span className="sr-only">Hent</span>
                </th>
              </>
            </TableHead>
            <TableBody>
              {orderBy(
                dataudtraek,
                sortBy.map((s) => s.field),
                sortBy.map((s) => s.direction),
              ).map((du, i) => {
                return (
                  <TableRow key={i}>
                    <>
                      {activeColumns
                        .filter((col) => col.active)
                        .map((col) => {
                          return <TD key={col.field} col={col} rowData={du} />;
                        })}
                      <td className="edit-column">
                        {(() => {
                          switch (du.type) {
                            case "kursuskategori":
                              return <KursusKategoriDownloadModalWithRoot />;
                            case "dateinterval":
                              return (
                                <DownloadModalWithRoot
                                  config={{
                                    title: du.navn,
                                    description: du.beskrivelse,
                                    link: du.link,
                                    fromDateParam: true,
                                    toDateParam: true,
                                  }}
                                />
                              );
                            case "default":
                              return (
                                <Button
                                  color="primary"
                                  icon
                                  transparent
                                  className="tooltip-center"
                                  aria-label="Hent udtræk..."
                                  onClick={async () => {
                                    try {
                                      await openReportWithAuth(du.link);
                                    } catch (e) {
                                      console.error(e);
                                    }
                                  }}
                                >
                                  <span className="icon-bg">
                                    <DownloadIcon />
                                  </span>
                                </Button>
                              );
                          }
                        })()}
                      </td>
                    </>
                  </TableRow>
                );
              })}
            </TableBody>
          </TableRoot>
        </ModalProvider>
      </div>
    </div>
  );
}

const defaultSortBy: SortBy[] = [
  {
    direction: "asc",
    field: "navn",
  },
];
